import { ReactElement, ElementType, useMemo } from 'react';

import {
  OrdersFiltersMenuV2Type,
  OrdersFiltersMenuV2VariantProps,
} from '../types';
import OrdersFiltersMenuV2VariantCollect from './Collect';
import OrdersFiltersMenuV2VariantInWarehouse from './InWarehouse';
import OrdersFiltersMenuV2VariantInTransit from './InTransit';
import OrdersFiltersMenuV2VariantFinalized from './Finalized';

const VARIANTS_COMPONENTS: Record<OrdersFiltersMenuV2Type, ElementType> = {
  collect: OrdersFiltersMenuV2VariantCollect,
  inWarehouse: OrdersFiltersMenuV2VariantInWarehouse,
  inTransit: OrdersFiltersMenuV2VariantInTransit,
  finalized: OrdersFiltersMenuV2VariantFinalized,
};

const OrdersFiltersMenuV2Variant = ({
  type,
}: OrdersFiltersMenuV2VariantProps): ReactElement => {
  const VariantComponent = useMemo(() => VARIANTS_COMPONENTS[type], [type]);

  return <VariantComponent />;
};

export default OrdersFiltersMenuV2Variant;
